import actionTypes from '../constants/action-types';

const setSocialIcons = (socialIcons) => ({
  type: actionTypes.SET_SOCIAL_ICONS,
  payload: {
    socialIcons,
  },
});

export default setSocialIcons;
